import React, { Component } from 'react'
import { Table, Button, Tooltip,Icon,Input,Divider } from 'antd'
import API from '../../../services/API'


class WarehousesListContainer extends Component {
	// eslint-disable-next-line react/state-in-constructor
	state = {
		data: [],
		loading: true,
		pagination: {},
		query:''
	}

	componentDidMount() {
		this.getData({
			page: 1,
        })
	}

	getData = ({ page = 1, filters = null, sorter = null }) => {
		// eslint-disable-next-line prefer-const
        let url = `/api/warehouses?per_page=10&page=${page}&include=subsidiary`;
        let newQuery = ''
        if (filters) {
			const keys = Object.keys(filters)
			keys.forEach((k) => {
				if (filters[k].length) {
                    if (k !== 'subsidjiary_id') {
                        newQuery += `&filter[${k}]=${filters[k][0]}`
                    }
				}
			})
        }
        if (sorter && Object.keys(sorter).length) {
			const order = sorter.order === 'descend' ? '-' : ''
			newQuery += `&sort=${order}${sorter.field}`
		}
        url += newQuery
		API.get(url)
			.then((response) => {
				this.setState({
					data: response.data.data,
					pagination: {
						// eslint-disable-next-line react/no-access-state-in-setstate
						...this.state.pagination,
						total: response.data.total,
					},
					loading: false,
					query:newQuery
				})
			})
			.catch(() => {
				this.setState({
					loading: false,
				})
			})
	}

	// eslint-disable-next-line no-unused-vars
	handleTableChange = (pagination, filters, sorter) => {
		// eslint-disable-next-line react/no-access-state-in-setstate
		const pager = { ...this.state.pagination }
		pager.current = pagination.current

		this.setState({
			pagination: pager,
			loading: true,
		})

		this.getData({
			page: pagination.current,
		})
	}
		// eslint-disable-next-line no-unused-vars
		handleSearch = (selectedKeys, confirm, column) => {
			confirm()
		}

	getColumnSearchProps = (dataIndex) => ({
		filterDropdown: ({
			setSelectedKeys,
			selectedKeys,
			confirm,
			clearFilters,
		}) => (
			<div style={{ padding: 8 }}>
				<Input
					ref={(node) => {
						this.searchInput = node
					}}
					placeholder={`Buscar`}
					value={selectedKeys[0]}
					onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
					onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
					style={{ width: 188, marginBottom: 8, display: 'block' }}
				/>
				<Button
					type="primary"
					onClick={() => this.handleSearch(selectedKeys, confirm)}
					icon="search"
					size="small"
					style={{ width: 90, marginRight: 8 }}
				>
					Buscar
				</Button>
				<Button
					onClick={() => this.handleReset(clearFilters)}
					size="small"
					style={{ width: 90 }}
				>
					Cancelar
				</Button>
			</div>
		),
		filterIcon: (filtered) => (
			<Icon
				type="search"
				style={{ color: filtered ? '#1890ff' : undefined }}
			/>
		),
		onFilterDropdownVisibleChange: (visible) => {
			if (visible) {
				setTimeout(() => this.searchInput.select())
			}
		},
	})

	render() {

		const columns = [{
				title: 'Nombre de almacen',
				dataIndex: 'name',
				sorter: false,
				...this.getColumnSearchProps('name'),
			},
			{
				title: 'Inventario',
				dataIndex: 'has_inventory',
				render: (label, row) => (row.has_inventory ? 'Si' : 'No'),
				filterMultiple: false,
				// Hay que ajustar los filtros de retorno, el valor en cada caso esta INCORRECTO
				filters: [{ text: 'Con Inventario', value: 1 }, { text: 'Sin inventario', value: 0 }],
				sorter: false,
			},
			{
				title: 'Sucursal',
				dataIndex: 'subsidiary_id',
				sorter: false,
				render: (label, row) => (row.subsidiary ? row.subsidiary.name : row.subsidiary_id),
			},

			{
				title: 'Activo',
				dataIndex: 'active',
				render: (label, row) => (row.active ? 'Si' : 'No'),
				filterMultiple: false,
				filters: [{ text: 'Activo', value: 1 }, { text: 'Inactivo', value: 0 }],
                sorter: false,
			},
			{
                title: 'Fecha de creación',
                dataIndex: 'created_at',
                sorter: false,
            },
            {
                title: 'Fecha de actualizacíón',
                dataIndex: 'updated_at',
                sorter: false,
            },
			{
				title: 'Acciones',
				dataIndex: '',
				key: 'x',
				render: (label, row) => (
						<div>
							<Button
								type="primary"
								shape="circle"
								icon="edit"
								size="small"
								style={{
									margin: 5,
								}}
								onClick={() => this.props.history.push(`/warehouses/edit/${row.id}`)}
							/>
						</div>
					),
		}]
		return (
            <div>

			<Divider>Listado de almacenes</Divider>

                <div className="ant-header-button" >
					<Tooltip title="Generar hoja de calculo" placement="left">
						{/* eslint-disable-next-line no-return-assign */}
						<Button style={{ marginRight: '10px' }} type="primary" shape="circle" icon="download" onClick={() => window.location.href = 'api/excel?table=warehouses&pagination=false&json=false'+this.state.query} />
					</Tooltip>
					<Tooltip title="Crear almacenes" placement="left">
                        <Button type="primary" shape="circle" icon="plus" onClick={() => this.props.history.push('/warehouses/create')} />
					</Tooltip>
                </div>
					<Table
						columns={columns}
						rowKey={(row) => row.id}
						dataSource={this.state.data}
						pagination={this.state.pagination}
						loading={this.state.loading}
						onChange={this.handleTableChange}
						bordered
						size="small"
					/>
            </div>
		)
	}
}

export default WarehousesListContainer
